<header class="app-header">
  <div class="left">
    <button class="icon" aria-label="Menu" (click)="toggleSidebar.emit()">
      <iconify-icon icon="mdi:menu" width="24" height="24"></iconify-icon>
    </button>

    <div class="brand">
      <img src="assets/logo.svg" alt="Hercules">
    </div>
  </div>

  <div class="right">
    <button class="icon" aria-label="Alternar Tema" (click)="toggleTheme()" title="Alternar tema claro/escuro">
      <iconify-icon
        [icon]="currentTheme === 'light' ? 'mdi:weather-night' : 'mdi:weather-sunny'"
        width="24"
        height="24">
      </iconify-icon>
    </button>

    <div class="profile" #profile [class.open]="menuOpen" (mouseenter)="onProfileEnter()" (mouseleave)="onProfileLeave()">
      <button class="icon avatar icon-user" aria-label="Perfil" aria-haspopup="menu" [attr.aria-expanded]="menuOpen" (click)="toggleMenu()">
        <iconify-icon icon="mdi:account-circle-outline" width="24" height="24"></iconify-icon>
          <iconify-icon icon="mdi:chevron-down" class="down" width="18" height="18"></iconify-icon>
      </button>

      <div class="menu" role="menu">
        <button role="menuitem" class="menu-item" (click)="onLogout(); $event.stopPropagation()">
          <iconify-icon icon="mdi:logout" width="18" height="18"></iconify-icon>
          <span>Sair</span>
        </button>
      </div>
    </div>
  </div>
</header>
